<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Dépôt de documents
        </p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Vous pouvez déposer les documents.
        </p>
      </div>
      <illustration
        name="depot_documents"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <div class="flex flex-col mt-15">
      <div
        v-if="allowed"
        class="relative align-middle min-w-full shadow rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
      >
        <h3 class="my-5 lg:my-15 2xl:my-20 w-full px-12">
          Dépôt de documents
        </h3>

        <files-list
          v-if="path.length > 0 || folders.length > 0 || files.length > 0"
          :folders="folders"
          :files="files"
          :color-by-type="colorByType"
          @openFolder="
            (folder) => {
              addFolderToPath(folder);
            }
          "
          @displayAllFiles="displayAllFiles()"
          @goto="
            (index) => {
              goToPath(index);
            }
          "
          :path="path"
        />

        <no-file-found
          v-if="path.length == 0 && folders.length == 0 && files.length == 0"
        />
      </div>
      <!-- display message when user not allow to use this function -->
      <page-not-allowed v-else />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Illustration from './../../components/Illustration';
import AddButton from './../../components/Inputs/AddButton';
import FolderCard from './../../components/DepotDocuments/FolderCard';
import Tag from './../../components/Tag';
import ListAvatars from './../../components/ListAvatars';
import Icon from './../../components/Icon';
import MessageHeader from '../../components/MessageHeader';
import PageNotAllowed from './../../components/PageNotAllowed.vue';
import NoFileFound from './NofileFound.vue';

import FilesList from './FilesList.vue';

import RootFolder from './RootFolder';
import CurrentFolder from './CurrentFolder';
import RecentFiles from './RecentFiles';

export default {
  name: 'Documents',

  components: {
    MessageHeader,
    Illustration,
    AddButton,
    FolderCard,
    Tag,
    ListAvatars,
    Icon,
    RootFolder,
    CurrentFolder,
    RecentFiles,
    PageNotAllowed,
    NoFileFound,
    FilesList,
  },

  data() {
    return {
      path: [],

      colorByType: {
        jpeg: 'teal',
        jpg: 'teal',
        gif: 'teal',
        bmp: 'teal',
        heic: 'teal',
        heif: 'teal',
        png: 'teal',
        doc: 'pink',
        docx: 'pink',
        pdf: 'indigo',
      },
    };
  },

  mounted() {
    //this.generateRawDatas(6, 50);
  },

  methods: {
    generateRawDatas(nbCreatedFolders, nbCreatedFiles) {
      let collaborators = [
        { firstname: 'David', lastname: 'Chhang', urlAvatar: '' },
        { firstname: 'Fabrice', lastname: 'Autissier', urlAvatar: '' },
        { firstname: 'Inès', lastname: 'Atallah', urlAvatar: '' },
        { firstname: 'Aurélien', lastname: 'Bouvaist', urlAvatar: '' },
        { firstname: 'Mélanie', lastname: 'Beffre', urlAvatar: '' },
        { firstname: 'Karine', lastname: 'Meyer', urlAvatar: '' },
      ];

      //Some folders
      let folderNames = [
        'Règlements',
        'Chartes',
        'Registres',
        'Comptes-rendus',
        'Synthèses',
        'Tableaux',
        'Lorem Ipsum',
        'Surveillance',
        'Fragile',
      ];
      let themes = ['indigo', 'pink', 'gray', 'teal', 'orange'];

      //Some files
      let fileType = ['PDF', 'DOC', 'JPG'];

      for (let index = 0; index < nbCreatedFiles; index++) {
        let type = fileType[Math.floor(Math.random() * fileType.length)];
        //let parentFolder = this.folders[(Math.floor(Math.random() * this.folders.length))];

        let colorTheme = 'default';

        switch (type) {
        case 'PDF':
          colorTheme = 'indigo';
          break;
        case 'DOC':
          colorTheme = 'pink';
          break;
        case 'JPG':
          colorTheme = 'teal';
          break;
        default:
          colorTheme = 'default';
          break;
        }

        let listCollaborators = [];

        for (let j = 0; j < Math.floor(Math.random() * 5); j++) {
          listCollaborators.push(collaborators[j]);
        }

        this.files.push({
          id: index + 1,
          folderId: 1,
          type: type,
          colorTheme: colorTheme,
          name: 'Fichier n°' + (index + 1),
          parentFolder: 'Test',
          sharedWith: listCollaborators,
          createdDate: new Date('01/01/2020'),
        });
      }
    },

    addFolderToPath(folder) {
      this.path.push(folder);
    },

    displayAllFiles() {
      this.path = ['allFiles'];
    },

    goToPath(pos) {
      if (pos == null) {
        this.path = [];
        return;
      }

      this.path = this.path.filter((p, i) => i <= pos);
    },
  },

  computed: {
    ...mapGetters({
      folders: 'depotDocuments/folders',
      files: 'depotDocuments/files',
      messageHeader: 'depotDocuments/messageHeader',
      allowed: 'app/allowed',
    }),
  },
};
</script>
